import React, { useState } from 'react'
import { useApi } from '../Store/ApiContext';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import crypto from 'crypto-js';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import UploadImages from '../UploadImages/UploadImages';
import PaymentMethods from '../PaymentMethods/PaymentMethods';
import { useNavigate } from 'react-router-dom';
// import { Nav, Tab, Tabs } from 'react-bootstrap';

export default function PaymentKashir({ baseUrl }) {

    const { responseApi, token, getSlug, decodeToken, postDataWithAuth, getData } = useApi();

    const navigate = useNavigate();

    const [order, setOrder] = useState("");
    const [orderId, setOrderId] = useState("");
    const [paymentToken, setPaymentToken] = useState("");
    const [mobileWalletResponse, setMobileWalletResponse] = useState({});

    const [bookingData, setBookingData] = useState(null);
    const [unitData, setUnitData] = useState(null);
    const [transaction, setTransaction] = useState(null);

    // Payment method states
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [paymentImage, setPaymentImage] = useState({ idsImg: [] });
    const [bookingPolicies, setBookingPolicies] = useState({});

    const [response, setResponse] = useState({})

    // ** test secret key
    // const secretKey = "f67d0c7aa1f4b93e73ac69aa7c97f4f2$6e6e2888a00f673747078e63d6bbf70e0ff19435ed4c947f03d8b3869362aea5b135f6b57033afe4df42d17baa494190";
    // ** live secret key
    const secretKey = "80b2e608d30298d9a89d9fddd2644940$b665b19990476502b6c417ab444db023374dd8e90ed13ee7632843871c335cf18891a3b85c3cd34b797d6354584431c5";
    const merchantAccountId = "MID-24239-822";

    // Load booking policies from backend
    const loadBookingPolicies = async () => {
        try {
            // booking policies
            const bookingPoliciesCached = sessionStorage.getItem(`bookingPolicies`);
            if (bookingPoliciesCached) {
                setBookingPolicies(JSON.parse(bookingPoliciesCached));
            } else {
                const data = await getData(`bookingPolicies/${getSlug()}`);
                if (data) {
                    setBookingPolicies(data.bookingPolicies);
                    sessionStorage.setItem("bookingPolicies", JSON.stringify(data.bookingPolicies));
                }
            }
        } catch (error) {
            console.error('Error loading booking policies:', error);
        }
    };

    async function sendRequestKashir(url, options) {
        const response = await fetch(url, options);
        const data = await response.json();
        return data
    }

    async function createInvoiceKashir() {

        const decoded = decodeToken()
        const url = 'https://api.kashier.io/paymentRequest?currency=EGP'
        const options = {
            method: 'POST',
            headers: { accept: 'application/json', 'content-type': 'application/json', "Authorization": secretKey },
            body: JSON.stringify({
                paymentType: "simple", // simple ===>>> payment request
                merchantId: merchantAccountId,
                customerName: decoded.firstName + " " + decoded.lastName,
                dueDate: moment().add(1, "h"),
                isSuspendedPayment: true,
                description: "unit renting",
                totalAmount: bookingData.reqTotalCost,
                invoiceItems: [],
                state: "submitted",
                currency: "EGP",
                extraFees: []
            })
        };
        const data = await sendRequestKashir(url, options);
        console.log(data);
        setOrder(data.response);
        return data.response?._id;
    }

    async function generateKashirOrderHashAndCreateOrderTransaction() {
        const myData = {
            paymentMethod: "",
            totalPaid: order.totalAmount,
            // commission : bookingData.reqTotalCost * (10/100),
            // fees : 3 + (bookingData.reqTotalCost * (2.75/100)),
            // ownerRevenue : bookingData.reqTotalCost - (bookingData.reqTotalCost * (10/100)) - (3 + (bookingData.reqTotalCost * (2.75/100))),
            currency: order.currency,
            orderId: order._id,
            plan: decodeToken().plan
        }
        const { data } = await postDataWithAuth("listing/payment/orderTransaction", myData);
        console.log(data);
        return data; // This will output the HMAC SHA-256 hash
    }

    function storeBookingData() {
        const data = {
            orderId: order._id, // check order Id

            // Booking Data
            reqFrom: bookingData.reqFrom,
            reqTo: bookingData.reqTo,
            reqGuests: bookingData.reqGuests,
            reqNights: bookingData.reqNights,
            reqTotalCost: bookingData.reqTotalCost,
            unit: bookingData.unit,
            orgPaymentMethod: bookingData.orgPaymentMethod,
            paymentImage: bookingData.paymentImage,

            // Renting Transaction Data
            paymentMethod: "",
            totalPaid: bookingData.reqTotalCost,
            // commission : bookingData.reqTotalCost * (10/100),
            // fees : 3 + (bookingData.reqTotalCost * (2.75/100)),
            // ownerRevenue : bookingData.reqTotalCost - (bookingData.reqTotalCost * (10/100)) - (3 + (bookingData.reqTotalCost * (2.75/100))),
            currency: order.currency,
        }
        sessionStorage.setItem("data", JSON.stringify(data));
    }

    async function redirectPaymentGateway() {
        storeBookingData()
        const orderHash = await generateKashirOrderHashAndCreateOrderTransaction();
        if (orderHash) {
            window.location.href = `https://checkout.kashier.io/?merchantId=${merchantAccountId}&orderId=${order._id}&amount=${order.totalAmount}&currency=${order.currency}&hash=${orderHash}&mode=live&allowedMethods=card,bank_installments,wallet&merchantRedirect=${window.location.origin}/unit/${bookingData.unit}&failureRedirect=${window.location.origin}/unit/${bookingData.unit}&paymentRequestId=${order.paymentRequestId}&serverWebhook=https://us-central1-prokfy-backend.cloudfunctions.net/app/api/v1/listing/payment/webhookServer&type=external&brandColor=${encodeURIComponent("#074acc")}&display=ar&saveCard=optional&interactionSource=Ecommerce&enable3DS=true`
        } else {
            toast.error("حدث خطأ ما. رجاء اعادة المحاولة", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                rtl: true
            });
        }
    }

    async function handlePaymentKashir() {
        setResponse(null)
        const orderId = await createInvoiceKashir();
        setResponse(orderId)
    }

    async function handleRequest() {
        // Check if ID images are uploaded
        if (!bookingData?.idsImg?.length) {
            toast.error("يرجي رفع صور للهوية / إثبات الشخصية", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                rtl: true
            });
            return;
        }

        // Check if payment method is selected when payment integration is disabled
        if (!bookingPolicies?.paymentPolicy?.paymentIntegrationEnabled && !selectedPaymentMethod) {
            toast.error("يرجى اختيار طريقة الدفع", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                rtl: true
            });
            return;
        }

        // Check if payment proof is uploaded for non-cash methods
        if (!bookingPolicies?.paymentPolicy?.paymentIntegrationEnabled &&
            selectedPaymentMethod &&
            selectedPaymentMethod !== 'cash' &&
            (!bookingData.paymentImage || bookingData.paymentImage.length === 0)) {
            toast.error("يرجى رفع إثبات الدفع", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                rtl: true
            });
            return;
        }

        const slug = getSlug();
        if (bookingPolicies.paymentPolicy?.paymentIntegrationEnabled) {
            await handlePaymentKashir();
        } else {
            await bookingWithoutPayment(slug);
        }
    }

    async function bookingWithoutPayment(slug) {
        // Booking Data
        const myData = {
            reqFrom: bookingData.reqFrom,
            reqTo: bookingData.reqTo,
            reqGuests: bookingData.reqGuests,
            reqNights: bookingData.reqNights,
            reqTotalCost: bookingData.reqTotalCost,
            unit: bookingData.unit,
            idsImg: bookingData.idsImg,
            orgPaymentMethod: bookingData.orgPaymentMethod,
            paymentImage: bookingData.paymentImage
        }
        const data = await postDataWithAuth(`listing/booking/bookingWithoutPayment/${slug}`, myData);
        console.log(data);
        if (data.message === "success") {
            toast.success("تم استقبال طلبك بنجاح. سيقوم فريقنا بالتواصل معك لتأكيد الحجز قريبا..", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                rtl: true
            });
            navigate("/");
        }
    }

    useEffect(() => {
        setBookingData(JSON.parse(sessionStorage.getItem("bookingData")));
        setUnitData(JSON.parse(sessionStorage.getItem("unitData")));
        setTransaction(JSON.parse(sessionStorage.getItem("transaction")));

        // // Load existing payment method data if available
        // const existingBookingData = JSON.parse(sessionStorage.getItem("bookingData"));
        // if (existingBookingData?.selectedPaymentMethod) {
        //     setSelectedPaymentMethod(existingBookingData.selectedPaymentMethod);
        // }
        // if (existingBookingData?.paymentImage) {
        //     setPaymentImage({ idsImg: existingBookingData.paymentImage });
        // }

        // Load booking policies
        loadBookingPolicies();
    }, [])

    useEffect(() => {
        if (order) {
            redirectPaymentGateway()
        }
    }, [order])

    // Update booking data in session storage when payment method or proof changes
    useEffect(() => {
        if (bookingData && (selectedPaymentMethod)) {
            const updatedBookingData = {
                ...bookingData,
                selectedPaymentMethod,
            };
            sessionStorage.setItem("bookingData", JSON.stringify(updatedBookingData));
        }
    }, [selectedPaymentMethod, paymentImage, bookingData])

    return (
        <>
            {bookingData && unitData && transaction && (
                <section className='payment-invoice min-h-screen pb-safe-area-inset-bottom'>
                    <div className='container mx-auto px-2 sm:px-4 lg:px-6 max-w-full'>
                        <div className='max-w-5xl mx-auto'>
                            {/* Header Section - Non-sticky */}
                            <div className='bg-gradient-to-l from-blue-600 to-blue-700 p-3 sm:p-6 text-white shadow-lg rounded-t-2xl sm:rounded-t-2xl'>
                                <div className='flex items-center justify-between'>
                                    <div className='flex-1'>
                                        <h2 className='text-lg sm:text-2xl lg:text-3xl font-bold mb-1 sm:mb-2'>تفاصيل الحجز</h2>
                                        <p className='text-blue-100 text-xs sm:text-base leading-tight'>مراجعة البيانات وإتمام عملية الدفع</p>
                                    </div>
                                    {/* Mobile total preview */}
                                    <div className='block sm:hidden bg-white/20 backdrop-blur-sm rounded-lg px-3 py-2'>
                                        <div className='text-xs text-blue-100 mb-1'>الإجمالي</div>
                                        <div className='text-lg font-bold text-white'>{bookingData?.reqTotalCost} ج.م</div>
                                    </div>
                                </div>
                            </div>

                            <div className='bg-white rounded-b-2xl sm:rounded-2xl sm:rounded-t-none shadow-lg overflow-hidden'>
                                <div className='p-2 sm:p-6 space-y-3 sm:space-y-6'>
                                    {/* Unit Details Card - Mobile Optimized */}
                                    <div className='bg-gradient-to-l from-gray-50 to-gray-100 rounded-xl p-3 sm:p-6 border border-gray-200 shadow-sm'>
                                        <div className='flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3'>
                                            <div className='flex-1 min-w-0'>
                                                <h3 className='text-base sm:text-xl lg:text-2xl font-semibold text-gray-800 mb-1 line-clamp-2'>{unitData.unitName}</h3>
                                                <h6 className='text-gray-500 mb-2 sm:mb-4 font-medium text-xs sm:text-base'>({unitData.unitCode})</h6>
                                            </div>
                                        </div>

                                        <div className='grid grid-cols-2 items-center gap-0 space-y-0'>
                                            <div className='flex items-center text-gray-600 bg-transparent'>
                                                <FontAwesomeIcon icon={faLocationDot} className='text-blue-600 ml-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0' />
                                                <span className='font-medium text-xs sm:text-base truncate'>{unitData.country}</span>
                                            </div>
                                            <div className='flex items-center text-gray-600 bg-transparent'>
                                                <FontAwesomeIcon icon={faBed} className='text-blue-600 ml-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0' />
                                                <span className='font-medium text-xs sm:text-base'>عدد الغرف: {unitData.bedrooms}</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Booking Dates Card - Mobile Grid */}
                                    <div className='bg-white rounded-xl p-3 sm:p-6 border border-gray-200 shadow-sm'>
                                        <h4 className='text-sm sm:text-lg lg:text-xl font-semibold text-gray-800 mb-3 flex items-center'>
                                            <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-500 rounded-full ml-2"></span>
                                            تفاصيل الحجز
                                        </h4>
                                        <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6'>
                                            <div className='bg-gradient-to-l from-green-50 to-green-100 rounded-lg p-3 border border-green-200'>
                                                <h6 className='text-green-800 font-medium mb-2 text-xs sm:text-base flex items-center'>
                                                    تاريخ الوصول
                                                </h6>
                                                <p className='text-green-900 font-semibold text-sm sm:text-lg lg:text-xl leading-tight'>
                                                    {moment(bookingData.reqFrom).format("ddd , DD MMM YYYY")}
                                                </p>
                                            </div>
                                            <div className='bg-gradient-to-l from-red-50 to-red-100 rounded-lg p-3 border border-red-200'>
                                                <h6 className='text-red-800 font-medium mb-2 text-xs sm:text-base flex items-center'>
                                                    تاريخ المغادرة
                                                </h6>
                                                <p className='text-red-900 font-semibold text-sm sm:text-lg lg:text-xl leading-tight'>
                                                    {moment(bookingData.reqTo).format("ddd , DD MMM YYYY")}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Cost Breakdown Card - Mobile Optimized */}
                                    <div className='bg-white rounded-xl p-3 sm:p-6 border border-gray-200 shadow-sm'>
                                        <h4 className='text-sm sm:text-lg lg:text-xl font-semibold text-gray-800 mb-3 flex items-center'>
                                            <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-yellow-500 rounded-full ml-2"></span>
                                            تفاصيل التكلفة
                                        </h4>

                                        {/* Transaction Details - Mobile Cards */}
                                        <div className='space-y-2 mb-4'>
                                            {transaction?.map((trans, i) => (
                                                <div key={i} className='bg-gray-50 rounded-lg p-3 border border-gray-100'>
                                                    {/* Mobile layout */}
                                                    {/* <div className='flex flex-col space-y-2 sm:hidden'>
                                                        <div className='flex items-center justify-between'>
                                                            <span className='text-xs text-gray-600'>المدة</span>
                                                            <span className='font-semibold text-blue-600 text-sm'>{trans.nights} ليلة</span>
                                                        </div>
                                                        <div className='flex items-center justify-between'>
                                                            <span className='text-xs text-gray-600'>السعر/ليلة</span>
                                                            <span className='font-semibold text-sm'>
                                                                {unitData.costInterval === "night" ? trans.price : (trans.price / 30.5).toFixed(2)} ج.م
                                                            </span>
                                                        </div>
                                                        <div className='flex items-center justify-between border-t border-gray-200 pt-2'>
                                                            <span className='text-sm text-gray-700 font-medium'>المجموع الفرعي</span>
                                                            <span className='text-base font-bold text-gray-800'>
                                                                {unitData.costInterval === "night" ?
                                                                    trans.nights * trans.price :
                                                                    (trans.nights * trans.price / 30.5).toFixed(2)
                                                                } ج.م
                                                            </span>
                                                        </div>
                                                    </div> */}
                                                    
                                                    {/* Desktop layout */}
                                                    <div className='flex justify-between items-center'>
                                                        <div className='text-gray-700 text-sm sm:text-base'>
                                                            <span className='font-semibold text-blue-600'>{trans.nights}</span> ليلة ×
                                                            <span className='font-semibold mx-1'>
                                                                {unitData.costInterval === "night" ? trans.price : (trans.price / 30.5).toFixed(2)}
                                                            </span> ج.م
                                                        </div>
                                                        <div className='text-base sm:text-lg lg:text-xl font-bold text-gray-800'>
                                                            {unitData.costInterval === "night" ?
                                                                trans.nights * trans.price :
                                                                (trans.nights * trans.price / 30.5).toFixed(2)
                                                            } ج.م
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Total Amount */}
                                        <div className='border-t border-gray-200 pt-4'>
                                            <div className='flex justify-between items-center py-3 px-4 bg-blue-50 rounded-lg border border-blue-200'>
                                                <div className='text-blue-800 font-semibold text-lg'>الإجمالي</div>
                                                <div className='text-2xl font-bold text-blue-900'>
                                                    {bookingData?.reqTotalCost} ج.م
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Upload Images Section - Mobile Enhanced */}
                                    <div className='bg-white rounded-xl p-3 sm:p-6 border border-gray-200 shadow-sm'>
                                        <h4 className='text-sm sm:text-lg lg:text-xl font-semibold text-gray-800 mb-3 flex items-center'>
                                            <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-purple-600 rounded-full ml-2"></span>
                                            رفع الهوية / إثبات الشخصية
                                        </h4>
                                        <div className='bg-purple-50 rounded-lg p-3 border border-purple-200 mb-3'>
                                            <p className='text-purple-800 text-xs sm:text-sm leading-relaxed'>
                                                مطلوب رفع صور واضحة للهوية الشخصية أو جواز السفر لجميع النزلاء
                                            </p>
                                        </div>
                                        <UploadImages 
                                            unitCode={unitData.unitCode} 
                                            pathImage={'IDs'} 
                                            bookingData={bookingData} 
                                            setBookingData={setBookingData} 
                                            keyImages='idsImg' 
                                        />
                                    </div>

                                    {/* Payment Methods Section - Mobile Enhanced */}
                                    {bookingPolicies?.paymentPolicy && !bookingPolicies?.paymentPolicy?.paymentIntegrationEnabled && (
                                        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-3 sm:p-6 border border-blue-200 shadow-sm">
                                            <h4 className="text-sm sm:text-lg lg:text-xl font-semibold text-blue-800 mb-3 flex items-center">
                                                <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-blue-600 rounded-full ml-2 animate-pulse"></span>
                                                طريقة الدفع
                                            </h4>
                                            {/* <div className="bg-white rounded-lg p-2 sm:p-4 border border-blue-100">/ */}
                                                <PaymentMethods
                                                    bookingPolicies={bookingPolicies}
                                                    selectedPaymentMethod={selectedPaymentMethod}
                                                    setSelectedPaymentMethod={setSelectedPaymentMethod}
                                                    bookingData={bookingData}
                                                    setBookingData={setBookingData}
                                                />
                                            {/* </div> */}
                                        </div>
                                    )}
                                </div>

                                {/* Bottom Action Button - Non-sticky */}
                                <div className='p-3 sm:p-6 bg-white border-t border-gray-200 sm:border-t-0 sm:bg-transparent'>
                                    <div className='sm:flex sm:justify-center'>
                                        <button
                                            className='w-full sm:w-auto bg-gradient-to-l from-blue-600 to-blue-700 text-white font-semibold py-4 px-6 sm:px-8 lg:px-12 rounded-xl shadow-lg hover:shadow-xl active:scale-95 sm:hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center space-x-2 text-sm sm:text-base lg:text-lg min-h-[52px] sm:min-h-[56px] touch-manipulation'
                                            onClick={handleRequest}
                                            disabled={
                                                !(response?.message || response) ||
                                                (!bookingPolicies?.paymentPolicy?.paymentIntegrationEnabled && !selectedPaymentMethod)
                                            }
                                        >
                                            {(response?.message || response) ? (
                                                <div className='flex items-center space-x-2'>
                                                    <span>
                                                        {getSlug() == "ghouse.stminaelmandara.com" ? "أحجز الآن" : "إتمام الدفع"}
                                                    </span>
                                                </div>
                                            ) : (
                                                <div className='flex items-center space-x-2'>
                                                    <Spinner size={"sm"} animation="border" variant="light" />
                                                    <span>جاري المعالجة...</span>
                                                </div>
                                            )}
                                        </button>
                                    </div>
                                    
                                    {/* Mobile-only terms notice */}
                                    <div className='mt-2 sm:hidden'>
                                        <p className='text-xs text-gray-500 text-center leading-relaxed'>
                                            بالمتابعة، أنت توافق على شروط وأحكام الخدمة
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}
